import React, { useState } from 'react';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import PricingConfigurationTab from './components/PricingConfigurationTab';
import OptionsManagementTab from './components/OptionsManagementTab';
import SystemSettingsTab from './components/SystemSettingsTab';
import AuditTrailTab from './components/AuditTrailTab';

const AdministrativeSettings = () => {
  const [activeTab, setActiveTab] = useState('pricing');

  const tabs = [
    {
      id: 'pricing',
      label: 'Tarification',
      icon: 'DollarSign',
      description: 'Configuration des prix et tarifs'
    },
    {
      id: 'options',
      label: 'Options',
      icon: 'Package',
      description: 'Gestion des options disponibles'
    },
    {
      id: 'system',
      label: 'Système',
      icon: 'Settings',
      description: 'Paramètres généraux'
    },
    {
      id: 'audit',
      label: 'Journal d\'audit',
      icon: 'Activity',
      description: 'Historique des modifications'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'pricing':
        return <PricingConfigurationTab />;
      case 'options':
        return <OptionsManagementTab />;
      case 'system':
        return <SystemSettingsTab />;
      case 'audit':
        return <AuditTrailTab />;
      default:
        return <PricingConfigurationTab />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="bg-surface border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <Breadcrumbs />
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <Icon name="Settings" size={24} className="text-primary" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-text-primary">
                    Paramètres administratifs
                  </h1>
                  <p className="text-text-secondary mt-1">
                    Configuration et gestion du système KitchenQuote Pro
                  </p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Button variant="outline" iconName="Download">
                  Exporter config
                </Button>
                <Button variant="outline" iconName="Upload">
                  Importer config
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar Navigation */}
          <div className="lg:w-64 flex-shrink-0">
            <div className="bg-surface border border-border rounded-lg p-4 sticky top-8">
              <h2 className="font-semibold text-text-primary mb-4">Sections</h2>
              <nav className="space-y-2">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`w-full flex items-center space-x-3 px-3 py-3 rounded-lg text-left transition-smooth ${
                      activeTab === tab?.id
                        ? 'bg-primary text-primary-foreground'
                        : 'text-text-secondary hover:text-text-primary hover:bg-muted'
                    }`}
                  >
                    <Icon name={tab?.icon} size={18} />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium">{tab?.label}</div>
                      <div className={`text-xs mt-1 ${
                        activeTab === tab?.id ? 'text-primary-foreground/80' : 'text-text-secondary'
                      }`}>
                        {tab?.description}
                      </div>
                    </div>
                  </button>
                ))}
              </nav>

              {/* Quick Actions */}
              <div className="mt-8 pt-6 border-t border-border">
                <h3 className="font-medium text-text-primary mb-3">Actions rapides</h3>
                <div className="space-y-2">
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Database"
                    className="w-full justify-start text-text-secondary hover:text-text-primary"
                  >
                    Sauvegarder
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="RefreshCw"
                    className="w-full justify-start text-text-secondary hover:text-text-primary"
                  >
                    Actualiser
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="HelpCircle"
                    className="w-full justify-start text-text-secondary hover:text-text-primary"
                  >
                    Aide
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {/* Tab Content */}
          <div className="flex-1 min-w-0">
            {renderTabContent()}
          </div>
        </div>
      </div>
      {/* Mobile Tab Navigation */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-surface border-t border-border z-40">
        <div className="flex items-center justify-around px-2 py-2">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`flex flex-col items-center space-y-1 px-3 py-2 rounded-md transition-smooth ${
                activeTab === tab?.id
                  ? 'text-primary bg-primary/10' :'text-text-secondary hover:text-text-primary'
              }`}
            >
              <Icon name={tab?.icon} size={20} />
              <span className="text-xs font-medium">{tab?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdministrativeSettings;